import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { ProjectLink } from "../../components/ProjectLink";
import { SiteLabel } from "../../components/SiteLabel";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import { DT_FORMATS } from "../../helpers/constants";
import type { Consumption } from "../../api-models";

export default function ConsumptionListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "Consumption.Write");

  return (
    <ListPage<Consumption>
      title="Consumption"
      endpoint="/consumptions"
      searchPlaceholder="Search doc no or notes..."
      linkTo={(r) => `/consumption/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/consumption/new")} data-tour="consumption-new">
            Record consumption
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Project", render: (_, r) => <ProjectLink project={r.project} /> },
        { title: "Site", render: (_, r) => r.site?.name },
        { title: "Date", dataIndex: "consumedOn", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.date) },
        // Whether a record has been posted is the question the list is scanned for now
        // that it takes an approval to get there.
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div>
            <SiteLabel site={r.site} project={r.project} /> — {dayjs(r.consumedOn).format(DT_FORMATS.date)}
          </div>
          <DocumentStatusTag status={r.status} />
        </div>
      )}
    />
  );
}
